import { CheckIcon } from '@heroicons/react/24/solid'
import clsx from 'clsx'
import type { ChangeEvent } from 'react'

export interface CheckboxProps {
  disabled?: boolean
  checked?: boolean
  center?: boolean
  id: string
  textSize?: 'text-xs' | 'text-sm' | 'text-base' | 'text-lg' | 'text-xl'
  label: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
}

const Checkbox = ({
  disabled,
  checked,
  id,
  label,
  center = false,
  textSize = 'text-base',
  onChange,
}: CheckboxProps) => (
  <div
    className={clsx('flex gap-2', {
      'items-center justify-center': center,
    })}
  >
    <div className="relative flex">
      <input
        id={id}
        type="checkbox"
        className="peer relative mr-1 size-6 shrink-0 cursor-pointer appearance-none border-2 border-teal-500 bg-transparent checked:border-0 checked:bg-teal-500 focus:outline-none"
        disabled={disabled}
        checked={checked}
        onChange={onChange}
      />
      <div className="pointer-events-none absolute hidden size-6 items-center justify-center peer-checked:flex">
        <CheckIcon className="size-4 fill-white stroke-white" />
      </div>
    </div>
    <label
      htmlFor={id}
      className={clsx('flex cursor-pointer items-center', textSize)}
    >
      {label}
    </label>
  </div>
)

export default Checkbox
